/**
 * @generated SignedSource<<1c0368e7fa7f679b4ae9414e45fec087>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type templateCatalogPaginationFragmentQuery$variables = {
  categoryID?: number | null;
  count?: number | null;
  cursor?: string | null;
  search?: string | null;
};
export type templateCatalogPaginationFragmentQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"templateCatalogPaginationFragment__productTemplates">;
};
export type templateCatalogPaginationFragmentQuery = {
  response: templateCatalogPaginationFragmentQuery$data;
  variables: templateCatalogPaginationFragmentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "categoryID"
  },
  {
    "defaultValue": 20,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": "1",
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = {
  "kind": "Variable",
  "name": "categoryID",
  "variableName": "categoryID"
},
v2 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v3 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v1/*:: as any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v2/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "templateCatalogPaginationFragmentQuery",
    "selections": [
      {
        "args": [
          (v1/*:: as any*/),
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v2/*:: as any*/)
        ],
        "kind": "FragmentSpread",
        "name": "templateCatalogPaginationFragment__productTemplates"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "templateCatalogPaginationFragmentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "ProductTemplatesConnection",
        "kind": "LinkedField",
        "name": "productTemplates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductTemplatesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Model",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "largeImageUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "filters": [
          "search",
          "categoryID"
        ],
        "handle": "connection",
        "key": "templateCatalogPaginationFragment_productTemplates",
        "kind": "LinkedHandle",
        "name": "productTemplates"
      }
    ]
  },
  "params": {
    "cacheID": "b27714fe6f64b734f5ff381a9fa5ca23",
    "id": null,
    "metadata": {},
    "name": "templateCatalogPaginationFragmentQuery",
    "operationKind": "query",
    "text": "query templateCatalogPaginationFragmentQuery(\n  $categoryID: Long = null\n  $count: Int = 20\n  $cursor: String = \"1\"\n  $search: String = \"\"\n) {\n  ...templateCatalogPaginationFragment__productTemplates_1auAvC\n}\n\nfragment templateCatalogPaginationFragment__productTemplates_1auAvC on Query {\n  productTemplates(first: $count, after: $cursor, search: $search, categoryID: $categoryID) {\n    edges {\n      node {\n        id\n        name\n        largeImageUrl\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "04438e46b9709da55706c9a71faeec0c";

export default node;
